<template>
    <div class="page">
        <div class="page-top"></div>
        <div class="serverTitle" ref="serverTitle">
            <p class="index-common_title tc">
                值得信赖的技术服务
            </p>
            <p class="index-common_subtitle tc">
                优质服务器，让您每一分钟都用的放心
            </p>
        </div>
        <div class="serviceList" ref="serviceList">
            <div class="item">
                <div class="item_img">
                    <img src="@/assets/img/index_img/3_icon_speed_normal.png" alt="111">
                </div>
                <div class="item_text">极速稳定</div>
                <div class="afterShow" @mouseover="afterShow($event)" @mouseout="afterShow($event)">
                  <!-- <h3>急速稳定</h3> -->
                  <p>跳转代理自有机房独享带宽，海量IP资源覆盖全国各地，线路绿色纯净高质量，稳定不掉线。 </p>
                </div>
            </div>
            <div class="item">
                <div class="item_img">
                    <img src="@/assets/img/index_img/3_icon_safety_normal.png" alt="111">
                </div>
                <div class="item_text">安全防护</div>
                <div class="afterShow" @mouseover="afterShow($event)" @mouseout="afterShow($event)">
                  <!-- <h3>安全防护</h3> -->
                  <p>跳转代理支持自动切换IP、过滤重复IP、自动清除cookies，高匿名，全程无后顾之忧。 </p>
                </div>
            </div>
            <div class="item">
                <div class="item_img">
                    <img src="@/assets/img/index_img/3_icon_server_normal.png" alt="111">
                </div>
                <div class="item_text">灵活配置</div>
                <div class="afterShow" @mouseover="afterShow($event)" @mouseout="afterShow($event)">
                  <!-- <h3>灵活配置</h3> -->
                  <p>可根据个人需求，配置自己所需要更换IP的进程与节点，独家定制独一无二的尊享配置。 </p>
                </div>
            </div>
            <div class="item">
                <div class="item_img">
                    <img src="@/assets/img/index_img/3_icon_configuration_normal.png" alt="111">
                </div>
                <div class="item_text">品质保证</div>
                <div class="afterShow" @mouseover="afterShow($event)" @mouseout="afterShow($event)">
                  <!-- <h3>品质保证</h3> -->
                  <p>专业技术团队7*24小时提供IP支持，强大的运维团队，创造稳定易用经济安全用户体验。 </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'service',
    props: {
        service_animation: Boolean
    },
    watch: {
       service_animation () {
           if(this.service_animation){
                this.$refs.serverTitle.classList.add("serverTitleAn")
                this.$refs.serviceList.classList.add("serviceListAn")
           }
       }
    },
    methods: {
      afterShow (e) {
        e.preventDefault()
        e.stopPropagation()
        if(e.target.classList.contains('afterShowAn')){
          e.target.classList.remove("afterShowAn")
          return
        }
        if(e.target.classList.contains('afterShow')) {
          e.target.classList.add("afterShowAn")
        }
      }
    }
}
</script>

<style lang="stylus" scoped>
    .page
        background-color #f3f3f3
    .page-top
        border-color #f5f7f9 transparent transparent
    .serverTitle
        transform translateY(-1rem)
        opacity 0
        transition all 1s ease
    .serviceList
        display flex
        justify-content center
        transform translateY(1rem)
        opacity 0
        transition all 1s ease
        width 1200px
        margin 0 auto
    .serverTitleAn, .serviceListAn
        transform translateY(0rem)
        opacity 1
    .serviceList .item
        width 6rem
        height 8rem
        background #ffffff
        position relative
        display flex
        flex-direction column
        text-align center
        background-size 100% 100%
        animation all 1s ease
     .serviceList .item .afterShow
        z-index 99
        opacity 1
        position absolute
        top 0
        bottom 0
        left 0
        right 0
        transition 1ss ease-in-out
        color #fff
        padding 0px 30px
        &:after
          content ''
          display block
          position absolute
          left 0
          right 0
          top 0
          bottom 0
    .serviceList .item .afterShow h3
        font-size 26px
        font-weight bold
        margin: 108px 0px 50px 0px;
    .serviceList .item .afterShow p
        height 99px
        font-size 14px
        font-family MicrosoftYaHei
        font-weight 400
        color rgba(255,255,255,1)
        line-height 28px
        padding-top 280px
        transition all .36s ease
        opacity 0
    .serviceList .item .afterShowAn p
        opacity 1
        transform translateY(-20px)
    .serviceList .item .item_img
        margin 80px 0px 25px 0px
        z-index 99
        transform translateY(0px)
        transition all .36s ease
        &:after
            content ''
            display block
            width .56rem
            height .05rem
            background red
            margin 0 auto
            background-color #cccccc
            margin-top 25px
    .serviceList .item .item_text
        color #fff
        font-weight bold
        font-size 22px
        z-index 99
        transform translateY(0px)
        transition all .36s ease
    .serviceList .item:nth-child(1)
        background-image url("~@/assets/img/index_img/3_image1_normal.png")
        &::after
          content ''
          display block
          height 10px
          background #32BF99
          width 100%
          position absolute
          bottom 0
          transition all .56s ease
        &:hover .item_text
          transform translateY(-10px)
        &:hover .item_img
          transform translateY(-10px)
    .serviceList .item:nth-child(2)
        background-image url("~@/assets/img/index_img/3_image2_normal.png")
        &::after
          content ''
          display block
          height 10px
          background #32BF99
          width 100%
          position absolute
          bottom 0
          transition all .56s ease
        &:hover .item_text
          transform translateY(-10px)
        &:hover .item_img
          transform translateY(-10px)
    .serviceList .item:nth-child(3)
        background-image url("~@/assets/img/index_img/3_image3_normal.png")
        &::after
          content ''
          display block
          height 10px
          background #32BF99
          width 100%
          position absolute
          bottom 0
          transition all .56s ease
        &:hover .item_text
          transform translateY(-10px)
        &:hover .item_img
          transform translateY(-10px)
    .serviceList .item:nth-child(4)
        background-image url("~@/assets/img/index_img/3_image4_normal.png")
        &::after
          content ''
          display block
          height 10px
          background #32BF99
          width 100%
          position absolute
          bottom 0
          transition all .56s ease
        &:hover .item_text
          transform translateY(-10px)
        &:hover .item_img
          transform translateY(-10px)
    .serviceList .item:hover::after
        height  100%
        opacity .92
     @media screen and (max-width: 1200px)
        .serviceList
            width auto
            margin auto
            padding 0 1rem
     @media screen and (max-width: 768px)
        .serviceList
            padding 0rem
            height auto
            &:after
                content ''
                display block
                height 0rem
                clear both
        .serviceList .item
            width 40%
            float left
            height 35%
        .serviceList .item .afterShow
            margin 0 auto
            display block
        .serviceList .item .afterShow h3
            margin 20px 0px
            font-size 20px
        .serviceList .item .afterShow p
            line-height 25px
        .serviceList .item .item_img
            margin .86rem 0rem
        .serviceList .item .item_text
            font-size 16px
            padding-bottom .36rem
    @media screen and (max-width: 456px)
        .serviceList
          display block
          padding 15px 10px
        .serviceList .item
          width 50%
        .serviceList .item .afterShow
          display none
</style>





// WEBPACK FOOTER //
// src/pages/Home/components/service.vue